// Scores
export const urlScoreWeights = [
  25, // Target Keyword Included
  25, // Length
  20, // Special Characters
  15, // URL Depth
  15, //LowerCase
];

// URL Length Check
export const urlSlugLengthCheck = (completeUrlLength, urlSlugWordsLength) => {
  // Mauvais : URL trop longue et slug trop court ou trop long
  if (
    completeUrlLength > 75 &&
    (urlSlugWordsLength > 5 || urlSlugWordsLength < 3)
  ) {
    if (urlSlugWordsLength > 5) {
      return {
        score: 0.5 * (5 / urlSlugWordsLength) * (75 / completeUrlLength) * 100,
        completeUrlLength: completeUrlLength,
        urlSlugLength: urlSlugWordsLength,
      };
    } else if (urlSlugWordsLength < 3) {
      return {
        score: 0.5 * (urlSlugWordsLength / 3) * (75 / completeUrlLength) * 100,
        completeUrlLength: completeUrlLength,
        urlSlugLength: urlSlugWordsLength,
      };
    }
  }

  // Moyen : URL ou slug trop long, mais moins sévèrement
  else if (
    completeUrlLength > 75 ||
    urlSlugWordsLength > 5 ||
    urlSlugWordsLength < 3
  ) {
    let score = 0;
    if (completeUrlLength > 75) {
      score = (75 / completeUrlLength) * 100;
    } else {
      if (urlSlugWordsLength > 5) {
        score = (5 / urlSlugWordsLength) * 100;
      } else if (urlSlugWordsLength < 3) {
        score = (urlSlugWordsLength / 3) * 100;
      }
    }
    return {
      score: score,
      completeUrlLength: completeUrlLength,
      urlSlugLength: urlSlugWordsLength,
    };
  }

  // Bon : URL courte et slug dans les bonnes limites
  else if (
    completeUrlLength <= 75 &&
    urlSlugWordsLength >= 3 &&
    urlSlugWordsLength <= 5
  ) {
    return {
      score: 100,
      completeUrlLength: completeUrlLength,
      urlSlugLength: urlSlugWordsLength,
    };
  }
};
